import {useAppSelector} from "../redux/store";
import type {menu} from "redux/reducers/authSlice";
import {useNavigate} from "react-router-dom";

export default function Menu(menuId: number) {
  // Menus which has child routs to needs replace history in navigate.
  const parentMenus = ["faculty", "alerts", "reports", "activity"];
  const navigate = useNavigate();
  const menus = useAppSelector(state => {
    return state?.auth?.userPreferences?.menus;
  });
  const result: menu[] = menus?.filter((ar: menu) => {
    return ar.id === menuId;
  });
  if (
    result?.length > 0 &&
    window.location.pathname === "/" + result[0]?.pageToLoad
  ) {
    const pageToLoad =
      result[0]?.subMenus[0]?.pages?.length === 0
        ? result[0]?.subMenus[0]?.pageToLoad
        : result[0]?.subMenus[0]?.pages[0]?.pageToLoad;

    if(parentMenus.includes(`/${window.location.pathname}`)){
      navigate(`/${pageToLoad}`,{replace : true});
    } else {
      navigate(`/${pageToLoad}`);
    }
  }
}
